import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { LanguageProvider } from './contexts/LanguageContext';
import NavigationBar from './components/NavigationBar';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <LanguageProvider>
      <div>
        <NavigationBar />
        <Home />
        <About />
        <Services />
        <Contact />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
